<template>
	<v-dialog v-model="openD" max-width="900" persistent>
		<v-card>
			<v-card-title class="headline">
				<span v-html="heading"></span>
			</v-card-title>
			<v-container fluid grid-list-md v-if="reporte">
				<v-layout row wrap>
					<v-flex xl3 lg3 md3 sm6 xs12 v-for="(dato, indexDato) in detalle" :key="`dato${indexDato}`">
						<div class="stats-card-title">
							<span class="fs-12 fw-normal">{{dato.label}}</span>
							<h5 class="mb-0 primary--text">{{dato.value}}</h5>
						</div>
					</v-flex>
				</v-layout>
				<v-layout row wrap>
					<v-flex md12 sm12 xs12>
						<v-text-field
								label="Número factura o CUFE"
								v-model="result.NoFactura"
								name="Número factura o CUFE"
								v-validate="'required'"
								:error-messages="errors.first('Número factura')"
						></v-text-field>
					</v-flex>
					<v-flex md6 sm12 xs12>
						<v-text-field
								label="Cuota moderadora"
								v-model.number="result.CuotaModer"
								name="Cuota moderadora"
								type="number"
								min="0"
								v-validate="'required|min_value:0|decimal:2'"
								:error-messages="errors.first('Cuota moderadora')"
						></v-text-field>
					</v-flex>
					<v-flex md6 sm12 xs12>
						<v-text-field
								label="Copago"
								v-model.number="result.Copago"
								name="Copago"
								type="number"
								min="0"
								v-validate="'required|min_value:0|decimal:2'"
								:error-messages="errors.first('Copago')"
						></v-text-field>
					</v-flex>
				</v-layout>
			</v-container>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
						@click="close"
						:disabled="load"
				>
					Cancelar
				</v-btn>
				<v-btn
						color="primary"
						:loading="load"
						:disabled="load"
						@click="submit"
				>
					Registrar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
  	props: ['heading'],
    data: () => ({
        openD: false,
        load: false,
        reporte: null,
        detalle: [],
		result: null,
        makeResult: {
			NoPrescripcion: null,
			TipoTec: null,
			ConTec: null,
			TipoIDPaciente: null,
			NoIDPaciente: null,
			NoEntrega: null,
			NoFactura: null,
			NoSubEntrega: null,
			NoIDEPS: null,
			CodEPS: null,
			CodSerTecAEntregado: null,
			CantUnMinDis: null,
			ValorUnitFacturado: null,
			ValorTotFacturado: null,
			CuotaModer: null,
			Copago: null,
			reporte_entrega_id: null
		}
	}),
	created () {
		this.resetResult()
	},
	methods: {
        submit () {
            this.$validator.validateAll().then(result => {
                if (result) {
                  this.loading()
					        this.result.reporte_entrega_id = this.reporte.id
                  const data = JSON.parse(JSON.stringify(this.result))
                  data.CuotaModer = this.valorDecimal(this.result.CuotaModer)
                  data.Copago = this.valorDecimal(this.result.Copago)
                  this.axios.post(`facturacion`, data)
                      .then((response) => {
                        this.$store.commit('snackbar', {color: 'success', message: `La facturación del reporte de entrega No. ${this.reporte.id} se registró correctamente`})
                        this.$store.commit('reloadTable', 'tableFacturacion')
                        this.$store.commit('reloadTable', 'tableReportesEntrega')
                        this.close()
                      }).catch(e => {
                        this.loading(false)
                        this.$store.commit('snackbar', {color: 'error', message: `al registrar la facturación del reporte de entrega No. ${this.reporte.id}`, error: e})
                      })
                }
            })
        },
		open (reporte) {
            this.reporte = reporte
			this.resetResult()
			this.result.NoPrescripcion = this.reporte.NoPrescripcion
			this.result.TipoTec = this.reporte.TipoTec
			this.result.ConTec = this.reporte.ConTec
			this.result.TipoIDPaciente = this.reporte.TipoIDPaciente
			this.result.NoIDPaciente = this.reporte.NoIDPaciente
			this.result.NoEntrega = this.reporte.NoEntrega
			this.result.NoSubEntrega = this.reporte.NoSubEntrega
			this.result.NoIDEPS = this.reporte.NoIDEPS
			this.result.CodEPS = this.reporte.CodEPS
			this.result.CodSerTecAEntregado = this.reporte.CodSerTecEntregado
			this.result.CantUnMinDis = Number(this.reporte.CantTotEntregada)
			this.result.ValorUnitFacturado = (this.reporte.ValorEntregado > 0 && this.result.CantUnMinDis > 0) ? ((this.reporte.ValorEntregado / this.result.CantUnMinDis).toFixed(0)).replace('.',',') : 0
			this.result.ValorTotFacturado = this.reporte.ValorEntregado

			this.detalle.push(
					{label: 'Id del reporte', value: this.reporte.id},
					{label: 'Prescripción', value: this.reporte.NoPrescripcion},
					{label: 'Serv/Tec entregado', value:  this.reporte.TipoTec + ' ' + this.reporte.CodSerTecEntregado},
					{label: 'Cantidad entregada', value:  this.reporte.CantTotEntregada},
					{label: 'Fecha entrega', value:  this.moment(this.reporte.FecEntrega).format('YYYY-MM-DD')},
					{label: 'Valor entregado', value:  this.currency(this.reporte.ValorEntregado)},
					{label: 'Identificación paciente', value:  this.reporte.TipoIDPaciente + this.reporte.NoIDPaciente}
			)

		  	this.openD = true
		},
		loading (val = true) {
		  this.load = val
		},
		resetResult () {
			this.result = JSON.parse(JSON.stringify(this.makeResult))
			this.detalle = []
			this.$validator.reset()
		},
		close () {
		  	this.openD = false
			setTimeout(() => {
                this.load = false
				this.resetResult()
			}, 300)
		}
  	}
}
</script>

